import api from './apiInstance';

export interface RoomSessionItem {
    id: number;
    roomId: string;
    roomName?: string;
    startDate: string; // ISO
    endDate?: string | null; // ISO or null if running
    listeners: number;
    stats?: string | null; // JSON string: { languages: { [code]: number } }
}

export interface RoomStatsResponse {
    items: RoomSessionItem[];
    total: number;
    pages: number;
    currentPage: number;
}

export async function getRoomStats(page = 1, limit = 100, roomId?: string): Promise<RoomStatsResponse> {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (roomId && roomId.trim()) {
        params.set('roomId', roomId.trim());
    }
    const url = `/room-stats?${params.toString()}`; // baseURL already includes /api
    const res = await api.get(url);
    const data = res.data?.data;
    return {
        items: data?.items ?? [],
        total: data?.total ?? 0,
        pages: data?.pages ?? 0,
        currentPage: data?.currentPage ?? page,
    } as RoomStatsResponse;
}
